export default r => {
  if (!r) return null;
  r = r / 1609.344;
  if (r === 0.25 || r === 0.5) {
    return r;
  } else {
    return Math.round(r);
  }
};
